<fieldset
  class="flex flex-col gap-1.5 border-0 m-0 p-0 min-w-0"
  [class]="containerClass()">
  <legend class="m-0 px-0 flex items-center gap-2">
    <span
      class="checklist-task-label label m-0"
      [class.sr-only]="hideLabel()"
      [attr.id]="labelId">
      {{ labelText() }}
    </span>
    @if (showClearButton) {
      <button
        type="button"
        class="flex items-center justify-center h-4 w-4 rounded text-button-secondary-color transition disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="state().disabled()"
        aria-label="Clear selection"
        (click)="clearSelection($event)">
        <svg-icon
          src="assets/svg/eraser.svg"
          svgClass="h-4 w-4"
          aria-hidden="true" />
      </button>
    }
  </legend>

  <div
    class="flex flex-col gap-2"
    role="radiogroup"
    [attr.aria-labelledby]="labelId">
    @for (option of optionList; track trackByOption($index, option)) {
      <div class="text-sm">
        <label
          class="relative flex w-full min-h-10 items-center gap-3 rounded px-1 text-sm select-none"
          [attr.for]="optionInputId($index)"
          [class.cursor-pointer]="!state().disabled()"
          [class.cursor-not-allowed]="state().disabled()">
          <input
            type="checkbox"
            class="absolute inset-0 z-10 m-0 h-full w-full opacity-0"
            [class.cursor-pointer]="!state().disabled()"
            [class.cursor-not-allowed]="state().disabled()"
            [id]="optionInputId($index)"
            [disabled]="state().disabled()"
            [checked]="isSelected(option)"
            (change)="onToggle(option, $event)"
            [attr.aria-checked]="isSelected(option)"
            [attr.aria-label]="option" />
          <span
            class="pointer-events-none relative flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-colors"
            [class]="indicatorClasses(option)">
            <span
              class="h-2.5 w-2.5 rounded-full bg-primary transition-transform duration-150 ease-in-out scale-0"
              [class.scale-100]="isSelected(option)">
            </span>
          </span>
          <span
            class="pointer-events-none leading-6"
            [class]="[
              state().disabled() ? 'text-quarternary' : 'text-primary',
              isSelected(option) ? 'font-semibold' : '',
            ]">
            {{ option }}
          </span>
        </label>
      </div>
    }
  </div>
  @if (state().touched() && state().errors().length > 0) {
    <p class="text-error-primary m-0 p-0">This is a required field</p>
  }
</fieldset>
